import { render } from "./WpePluginsHooks.vue?vue&type=template&id=998eec6a"
import script from "./WpePluginsHooks.vue?vue&type=script&lang=js"
export * from "./WpePluginsHooks.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/info/WpePluginsHooks.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "998eec6a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('998eec6a', __exports__)) {
    api.reload('998eec6a', __exports__)
  }
  
  module.hot.accept("./WpePluginsHooks.vue?vue&type=template&id=998eec6a", () => {
    api.rerender('998eec6a', render)
  })

}


export default __exports__